import * as angular from 'angular';

import { ComponentDefinition, KeyValuePair, AutoApprovalMethod } from '../../models/index';

class AutoApprovalMethodPickerController implements angular.IComponentController {
    static $inject = [];

    levels: KeyValuePair<AutoApprovalMethod, string>[] = [
        { key: AutoApprovalMethod.None, value: 'None' },
        { key: AutoApprovalMethod.ByDelay, value: 'After deadline' }
    ];

}

export const wtAutoApprovalMethodPicker: ComponentDefinition = {
    componentId: 'wtAutoApprovalMethodPicker',
    controller: AutoApprovalMethodPickerController,
    template: require('./autoApprovalMethodPicker.component.html'),
    controllerAs: 'vm',
    bindings: {
        isDisabled: '<?',
        model: '=',
        name: '@'
    }
};